import PropTypes from 'prop-types';
import './PageLoader.scss';

export const PageLoader = ({ loaderClass }) => {
  return (
    <div className={`page-loader ${loaderClass}`}>
      <div className="spinner"></div>
    </div>
  );
}

PageLoader.prototype = {
  loaderClass: PropTypes.string
};